module.exports = __webpack_public_path__ + "img/list-pattern1.55f9372.svg";